export const ENTERPRISE_ID = "ENTERPRISE_EVENT_ID"
export const ENTERPRISE_NAME = "ENTERPRISE_EVENT_NAME"
export const ENTERPRISE_URL = "ENTERPRISE_EVENT_URL"